import { blobMediaUrl } from "@/lib/blob-url"
// Team faces shown inside the floating launcher button (stacked
// person-in-a-bubble). Kept in sync with the Contact-page team bubbles
// so returning visitors see the same people across surfaces.

export interface LauncherTeamMember {
  src: string
  alt: string
}

export const LAUNCHER_TEAM: readonly LauncherTeamMember[] = [
  { src: blobMediaUrl("/images/team/nick.png"), alt: "Nick" },
  { src: blobMediaUrl("/images/team/ferdinand.png"), alt: "Ferdinand" },
  { src: blobMediaUrl("/images/team/dennis.png"), alt: "Dennis" },
  { src: blobMediaUrl("/images/avatars/laura.png"), alt: "Laura" },
]
